import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getSelectedLayout } from './get-selected-layout.esm.js';
import { sameArray } from './same-array.esm.js';
import { sortLayouts } from './sort-layouts.esm.js';

function applyLayout(layouts, newLayout) {
  var oldLayout = getSelectedLayout(layouts);
  if (oldLayout.id === newLayout.id && sameArray(oldLayout.fields, newLayout.fields)) {
    return layouts;
  }
  var layoutToAdd = _objectSpread2(_objectSpread2({}, newLayout), {}, {
    selected: true
  });
  var result = layouts.filter(function (l) {
    return l.id !== layoutToAdd.id;
  }).map(function (l) {
    return l.selected ? _objectSpread2(_objectSpread2({}, l), {}, {
      selected: false
    }) : l;
  });
  result = [].concat(_toConsumableArray(result), [layoutToAdd]);
  result = result.filter(function (l) {
    return l.selected || l.type !== LayoutType.Custom;
  });
  return sortLayouts(result);
}

export { applyLayout };
//# sourceMappingURL=apply-layout.esm.js.map
